import JsCookies, { CookieAttributes } from 'js-cookie';
import { LocalCache } from "./LocalCache";
import config from '../../config/config';

export class Cookies<T extends object = object> implements LocalCache<T> {
  constructor(
    private readonly options: CookieAttributes = {
      expires: 1, // 1 day,
      secure: config.env === 'production',
      sameSite: 'strict',
    }
  ) {}

  public get(key: string): string | undefined {
    return JsCookies.get(key);
  }

  public getJson(key: string): T | undefined {
    return JsCookies.getJSON(key);
  }

  public set(key: string, value: string | T): void {
    JsCookies.set(key, value, this.options);
  }

  public remove(key: string): void {
    JsCookies.remove(key, this.options);
  }

  public static create<T extends object = object>(options?: CookieAttributes): LocalCache<T> {
    return new Cookies(options);
  }
}

export default Cookies;
